import { TitleWithBorder } from "./TitleWithBorder";

export default TitleWithBorder;
